import React, { PureComponent } from 'react';
import CreateTransaction from './CreateTransaction';
import LedgerTable from './LedgerTable';
import enums from "../../../constants/enums";

class LedgerView extends PureComponent {
  render() {
    const {
      ledgers,
      openCreateModal,
      setViewMode,
      viewMode
    } = this.props;

    return (
      <div>
        <div className="filters-container admin-payment-filters-view">
          <div className="form-group">
            <label>Grouping Mode</label>
            <select
              value={viewMode}
              onChange={(e)=> setViewMode(e.target.value)}
            >
              <option value="all">No Grouping</option>
              <option value="currency">By Currency</option>
              <option value="accountCurrency">By Account/Currency</option>
            </select>
          </div>
        </div>
        <div className="ledger-page page">
          <div className="actions main-actions">
            <button className="button" type="button" onClick={openCreateModal}>Add Transaction</button>
          </div>
          {Object.keys(ledgers[viewMode]).map((key)=>{
            const ledger = ledgers[viewMode][key];
            return (
              <LedgerTable
                key={key}
                transactions={ledger.transactions}
                total={ledger.total}
                title={ledger.title}
                currency={ledger.currency}
              />
            )
          })}


          <CreateTransaction />

        </div>
      </div>
    )
  }
}

export default LedgerView;



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Ledger/Ledger.view.js